export var _paragraphListTheme = {
  baseStyle: () => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },
    bulletWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    bullet: {
      height: '4px',
      width: '4px',
      backgroundColor: 'neutral.black',
      borderRadius: 'full',
      display: 'inline-block'
    },
    number: {
      wordBreak: 'keep-all'
    },
    listItem: {
      listStyleType: 'none',
      display: 'flex'
    }
  }),
  sizes: {
    large: _ref => {
      var {
        icon,
        type
      } = _ref;
      return {
        container: {
          gap: type === 'unordered' && !icon ? 'xxs' : 'm'
        },
        bulletWrapper: {
          height: '24px',
          width: '24px'
        },
        number: {
          textStyle: 'body2Semi'
        },
        listItem: {
          gap: icon ? 's' : 'xxs'
        }
      };
    },
    small: _ref2 => {
      var {
        icon,
        type
      } = _ref2;
      return {
        container: {
          gap: type === 'unordered' && !icon ? 'xxxs' : 's'
        },
        bulletWrapper: {
          height: '20px',
          width: '20px'
        },
        number: {
          textStyle: 'body3Semi'
        },
        listItem: {
          gap: icon ? 's' : 'xxs'
        }
      };
    }
  },
  defaultProps: {
    size: 'small'
  }
};
//# sourceMappingURL=_ParagraphList.theme.js.map